import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FilteredAccount, ISelectedAccount, RejectedAccount } from '@interfaces/models';
import { select, Store } from '@ngrx/store';
import {
  getFormattedAccounts,
  getSelectedAccountPayload,
  getShortAccountDisplayName,
} from '@shared/helpers';
import { InternalTransferDetailsContent } from '@shared/services/content/content-jsons/internal-transfer-details-content';
import * as fromRootStore from '@store/index';
import { UpdateInternalTransferFromAccount, UpdateSelectedPositions } from '@store/index';
import { selectEligibleInternalTransferFromAccountsWithRejects } from '@store/selectors/client-accounts/client-accounts.selectors';
import { SelectModule } from '@vg-constellation/angular-18/select';
import { first, Observable } from 'rxjs';

import { IneligibleAccountsComponent } from '../ineligible-accounts/ineligible-accounts.component';

@Component({
  selector: 'app-transfer-details-from-dropdown',
  templateUrl: './transfer-details-from-dropdown.component.html',
  styleUrls: ['./transfer-details-from-dropdown.component.scss'],
  standalone: true,
  imports: [AsyncPipe, ReactiveFormsModule, SelectModule, IneligibleAccountsComponent],
})
export class TransferDetailsFromDropdownComponent implements OnInit {
  @Input() accountFrom!: FormControl;
  @Input() mode: 'transfer-details' | 'from-to' = 'transfer-details';

  selectedAccount$: Observable<ISelectedAccount | null>;
  displayedAccounts: FilteredAccount[] = [];
  rejectedAccounts: RejectedAccount[] = [];

  content = InternalTransferDetailsContent;
  getAccountName = getShortAccountDisplayName;

  constructor(private globalStore: Store<fromRootStore.State>) {
    this.selectedAccount$ = this.globalStore.pipe(
      select(fromRootStore.selectInternalTransferAccountFrom),
    );

    this.globalStore
      .pipe(
        select(selectEligibleInternalTransferFromAccountsWithRejects(this.rejectedAccounts)),
        first(),
      )
      .subscribe((eligibleInternalTransferFromAccounts) => {
        this.displayedAccounts = getFormattedAccounts(
          eligibleInternalTransferFromAccounts.accounts,
        );
      });
  }

  ngOnInit() {
    this.selectedAccount$.pipe(first()).subscribe((account: ISelectedAccount | null) => {
      if (!account) return;
      const index = this.displayedAccounts.findIndex(
        (acc) => acc.accountId === account.accountData.accountId,
      );
      index !== -1 ? this.accountFrom.patchValue(index.toString()) : this.accountFrom.reset();
    });

    this.accountFrom.valueChanges.subscribe((index: string) => {
      const data = {
        payload: getSelectedAccountPayload(this.displayedAccounts[+index], index),
      };
      this.globalStore.dispatch(UpdateInternalTransferFromAccount(data));
      this.globalStore.dispatch(UpdateSelectedPositions({ payload: [] }));
    });
  }

  get hasError() {
    return this.accountFrom.touched && this.accountFrom.invalid;
  }
}
